import { render, staticRenderFns } from "./QuizVersion.vue?vue&type=template&id=dbf8f622&scoped=true&"
import script from "./QuizVersion.vue?vue&type=script&lang=ts&"
export * from "./QuizVersion.vue?vue&type=script&lang=ts&"
import style0 from "./QuizVersion.vue?vue&type=style&index=0&id=dbf8f622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf8f622",
  null
  
)

export default component.exports